import { checkObjectMask } from '@shared/validators/validators.util';

export const WarehouseKeys = [
  'CategoryOfWarehouse',
  'Description',
  'DescriptionRu',
  'PlaceMaxWeightAllowed',
  'Ref',
  'TotalMaxWeightAllowed',
  'TypeOfWarehouse',
];
export const warehouseResultMaskValidator = checkObjectMask(WarehouseKeys);

export const internationalWarehouseKeys = [
  'FullDescription',
];
export const internationalwarehouseResultMaskValidator = checkObjectMask(internationalWarehouseKeys);
